<template>
  <div id="app">
    <div class="dropdown" ref="dropdown">
      <button class="dropbtn" @click="toggleDropdown">
        <i class="fas fa-bars"></i>
      </button>
      <div class="dropdown-content" :class="{ show: isOpen }">
        <router-link to="/" @click="closeDropdown">Big 2 Stats</router-link>
        <router-link to="/big2-form" @click="closeDropdown">Big 2 Form</router-link>
        <router-link to="/big2-results" @click="closeDropdown">Big 2 Results</router-link>
        <router-link to="/big2-charts" @click="closeDropdown">Big 2 Charts</router-link>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'App',
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    toggleDropdown() {
      this.isOpen = !this.isOpen;
    },
    closeDropdown(event) {
      if (
        event &&
        this.$refs.dropdown.contains(event.target) &&
        event.target.closest('.dropbtn')
      ) {
        return;
      }
      this.isOpen = false;
    },
    handleOutsideClick(event) {
      if (!this.$refs.dropdown.contains(event.target)) {
        this.isOpen = false;
      }
    },
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick);
  },
  beforeUnmount() {
    document.removeEventListener('click', this.handleOutsideClick);
  },
};
</script>
<style>
/* 1. Reset the body margin to remove the white gap */
body, html {
  margin: 0;
  padding: 0;
}
@font-face {
  font-family: 'Formula1-Regular';
  src: url('@/assets/fonts/Formula1-Regular.otf') format('opentype');
}
@font-face {
  font-family: 'Formula1-Bold';
  src: url('@/assets/fonts/Formula1-Bold.otf') format('opentype');
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.dropbtn {
  margin-top: 10px;
  background-color: #d0021b;
  color: white;
  padding: 12px 14px;
  font-size: 14px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.dropdown {
  position: relative;
  display: inline-block;
}
.dropdown-content {
  display: block;
  position: absolute;
  top: calc(100% + 10px);
  left: 50%;
  min-width: 190px;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.18);
  font-family: 'Formula1-Regular', sans-serif;
  font-size: medium;
  overflow: visible;
  z-index: 10;

  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateX(-50%) translateY(-8px);
  transition: opacity 0.2s ease, transform 0.2s ease, visibility 0.2s;
}
/* Invisible bridge over the visual gap so moving the mouse from the
   button down to the menu doesn't pass through a dead zone and break
   the :hover chain. Purely a hit-testing area, no visible styling. */
.dropdown-content::before {
  content: '';
  position: absolute;
  top: -10px;
  left: 0;
  right: 0;
  height: 10px;
}
.dropdown-content > *:first-child {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.dropdown-content > *:last-child {
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.dropdown:hover .dropdown-content,
.dropdown-content.show {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
  transform: translateX(-50%) translateY(0);
}
.dropdown-content a {
  color: #2c3e50;
  padding: 14px 20px;
  text-decoration: none;
  display: block;
  font-size: 14px;
  text-align: left;
  border-left: 3px solid transparent;
  border-bottom: 1px solid #eee;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}
.dropdown-content a:last-child {
  border-bottom: none;
}
.dropdown-content a:hover {
  background-color: #fdecec;
  border-left: 3px solid #d0021b;
  color: #d0021b;
}
.dropdown:hover .dropbtn {
  background-color: #b10000;
}
</style>
